import { Component } from "@angular/core";

/**
 * Onglet paramètres
 *
 * @author Guillaume TRAVOT
 * @date 26/04/2024
 */
@Component({
    host: {'data-test-id': 'ordonnanceur-parametres'},
    templateUrl: './ordonnanceur-parametres.component.html'
})
export class OrdonnanceurParametresComponent {}
